import axios from "axios";
import moment from "moment";

angular.module('AccountingBoxApp')
    .controller('SignupCtrl', function ($scope, $window, $rootScope, $location, User, $state, Auth, Company) {
        $scope.user = {};
        $scope.company = {};
        $scope.errors = {};
        $scope.singedUp = false;
        $window.document.title = 'Maak een gratis account aan - AdministratieBox';

        $scope.onCompanySelect = function(company) {
            console.log('company',$scope.company);
            $scope.company = _.assign($scope.company, company);
        };

        $scope.register = function (form, demo) {
            $scope.submitted = true;
            console.log('form is:', $scope.demo);
            if (!form.$valid) {
              return;
            }
            (async () => {
                let data;
                try {
                  const response = await axios.post(API_ENDPOINT + '/users/sign-up', {
                    user: $scope.user,
                    company: $scope.company,
                  });
                  data = response.data;

                  const login = await User.login({
                    email: $scope.user.email,
                    password: $scope.user.password
                  }).$promise;
                  console.log('login.user',login.user);
                  Auth.setCurrentUser(login.user);

                  const company = await Company.findOne({
                    filter: {
                      where: {
                        id: data.company.id
                      },
                      include: 'users'
                    }
                  }).$promise;
                  $rootScope.currentCompany = company;
                  analytics.alias(login.user.id);
                  $rootScope.sendAnalytics();
                  analytics.track('Signed Up');
                  analytics.track('Logged In');
                  $state.go('app.company.sale.invoiceSettings', { companySlug: company.slug });
                  $scope.$apply();
                }catch (error) {
                  let err = error.response?.data;
                  $scope.errors = {};
                  if (err?.error?.details?.codes?.email && err?.error?.details?.codes?.email[0] === 'uniqueness') {
                    $scope.errors.other = 'E-mailadres is al geregistreerd.';
                  }else if(err?.error?.message){
                    $scope.errors.other = err.error.message;
                  }else {
                    $scope.errors.other = 'Registreren mislukt. Probeer het later nog eens.';
                  }
                  $scope.$apply();
                }
              })();
        };

    });
